import { apiClient } from './client'
import type { ApiResponse } from './client'
import type {
  DomainSuppressionListDto,
  DomainSuppressionEntryDto,
  DomainSuppressionListQuery,
  DomainSuppressionCreatePayload,
  DomainSuppressionImportPayload,
  DomainSuppressionImportResultDto,
} from '@/types/domainSuppressions'

const base = (clientCompanyId: string) => `/api/ClientCompanies/${clientCompanyId}/Suppressions/Domains`

export const domainSuppressionsApi = {
  // One page of the company's blocked domains. Optional domain search + active filter.
  list: (clientCompanyId: string, query: DomainSuppressionListQuery = {}): Promise<ApiResponse<DomainSuppressionListDto>> => {
    const params = new URLSearchParams()
    if (query.search) params.set('search', query.search)
    if (query.active !== undefined) params.set('active', String(query.active))
    if (query.skip !== undefined) params.set('skip', String(query.skip))
    if (query.take !== undefined) params.set('take', String(query.take))
    const qs = params.toString()
    return apiClient.get(`${base(clientCompanyId)}${qs ? `?${qs}` : ''}`)
  },

  // Manually block one domain (Admin Action source). 422 on a blank/invalid or free/public domain.
  add: (clientCompanyId: string, payload: DomainSuppressionCreatePayload): Promise<ApiResponse<DomainSuppressionEntryDto>> =>
    apiClient.post(base(clientCompanyId), payload),

  // Remove a blocked domain. Idempotent 204.
  remove: (clientCompanyId: string, domain: string): Promise<ApiResponse<void>> =>
    apiClient.delete(`${base(clientCompanyId)}?domain=${encodeURIComponent(domain)}`),

  // Bulk-import a customer-supplied domain list (Import source). Returns an outcome tally.
  import: (clientCompanyId: string, payload: DomainSuppressionImportPayload): Promise<ApiResponse<DomainSuppressionImportResultDto>> =>
    apiClient.post(`${base(clientCompanyId)}/Import`, payload),
}
